import HttpHeaders, { Header } from './HttpHeaders'

export default HttpHeaders
export { Header }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Playground/HttpHeaders/index.ts